import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { OrderingOption } from 'generated/graphql-types';
import { extensionGroupRoute } from 'src/app/app-routing.module';
import { EntityRegisterView } from 'src/app/common-components/register/models/register-view';
import { ExtensionGroupPrivileges } from '../models/extension-group-privileges';
import { ExtensionGroupRegisterOptions } from '../models/extension-register-options';
import { ExtensionGroupRegisterListItem } from '../models/extension-register-results.model';
import { selectQuickFilters } from '../state/extension-group-register.reducer';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-extension-group-register-view',
    styleUrls: ['./extension-group-register-view.component.scss'],
    templateUrl: './extension-group-register-view.component.html',
    standalone: false
})
export class ExtensionGroupRegisterViewComponent extends EntityRegisterView<
   ExtensionGroupRegisterListItem,
   ExtensionGroupRegisterOptions,
   OrderingOption
> {
   protected selectQuickFilters(): (state: object) => ExtensionGroupRegisterOptions | null {
      return selectQuickFilters;
   }
   @Input() extensionGroupPrivileges: ExtensionGroupPrivileges;

   @Input() accountId: number | null;

   getRouterLink(id: number) {
      return `/${extensionGroupRoute}/${id}`;
   }

   public canAddExtensionGroups(): boolean {
      if (!this.extensionGroupPrivileges.canAdd) {
         return false;
      }
      return true;
   }
}
